export var UserRole = /*#__PURE__*/function (UserRole) {
  UserRole["SUPERUSER"] = "SUPERUSER";
  UserRole["ADMINISTRATOR"] = "ADMINISTRATOR";
  // TODO: possibly the MANAGER role can be determined fully based on granted abilities, making an explicit MANAGER role unnecessary.
  UserRole["MANAGER"] = "MANAGER";
  UserRole["REGISTERED"] = "REGISTERED";
  UserRole["GUEST"] = "GUEST";
  return UserRole;
}(UserRole || {});
export const UserRoles = Object.values(UserRole);
export const UserRoleOptions = UserRoles.map(v => {
  return {
    label: v,
    value: v
  };
});
/**
 * UserRoles are hierarchical. a SUPERUSER should pass role checks against ANY UserRole.
 * This Map helps to rank the UserRoles.
 */
export const UserRoleRank = {
  [UserRole.SUPERUSER]: 100,
  [UserRole.ADMINISTRATOR]: 50,
  [UserRole.MANAGER]: 30,
  [UserRole.REGISTERED]: 10,
  [UserRole.GUEST]: 1
};
export function roleCheck(requested, granted, respectSuperuser = true) {
  const negated = requested.startsWith('!');
  const requestedRole = negated ? requested.substring(1) : requested;
  if (negated) {
    // if(respectSuperuser && granted === UserRole.SUPERUSER) return true;
    return UserRoleRank[granted] < UserRoleRank[requestedRole];
  }
  ;
  return UserRoleRank[granted] >= UserRoleRank[requestedRole];
}
export function isUserRoleCheckValue(value) {
  if (typeof value !== 'string') throw new Error('isUserRoleCheckValue received value of invalid type: ' + value);
  if (value.startsWith('!')) value = value.substring(1);
  return [...UserRoles].includes(value);
}
export function findAllRolesSatisfyingRank(role) {
  const baseRank = UserRoleRank[role];
  const satisfyingRoles = Object.entries(UserRoleRank).filter(([r, rank]) => {
    return rank >= baseRank;
  }).map(([r, rank]) => r);
  return satisfyingRoles;
}